import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// import { DashboardComponent } from './dashboard';
import { ScheduleComponent } from './schedule';
import { ChangePasswordComponent } from './change-password';
import { UserDetailComponent } from './user';

import { Authguard } from './../../helper';
import { Roles } from './../../model';

const routes: Routes = [
    { path: '', redirectTo: 'schedule', pathMatch: 'full' },
    {
      path: '',
      children: [
        // {
        //   path: 'dashboard',
        //   component: DashboardComponent,
        //   data: { title: 'Dashboard' }
        // },
        {
          path: 'schedule',
          component: ScheduleComponent,
          data: { title: 'Work Schedule' }
        },
        {
          path: 'users',
          loadChildren: './user/user.module#UserModule',
          canActivate: [ Authguard ],
          data: {
            permission: {
              role: [Roles.Admin],
              redirectTo: '403'
            }
          }
        },
        {
          path: 'my-profile',
          component: UserDetailComponent,
          data: { title: 'My Profile' }
          // canActivate: [ Authguard ],
          // data: {
          //   permission: {
          //     role: roles.admin,
          //     redirectTo: '403'
          //   }
          // }
        },
        {
          path: 'customers',
          loadChildren: './customer/customer.module#CustomerModule'
        },
        {
          path: 'equipment',
          loadChildren: './equipment/equipment.module#EquipmentModule'
        },
        {
          path: 'job',
          loadChildren: './job/job.module#JobModule'
        },
        {
          path: 'site',
          loadChildren: './site/site.module#SiteModule'
        },
        {
          path: 'preventive-maintenance',
          loadChildren: './preventive-maintenance/preventive-maintenance.module#PreventiveMaintenanceModule'
        },
        {
          path: 'service',
          loadChildren: './service-call/service-call.module#ServiceCallModule'
        },
        {
          path: 'e-call',
          loadChildren: './ecall/ecall.module#EcallModule'
        },
        {
          path: 'product-category',
          loadChildren: './product-category/product-category.module#ProductCategoryModule',
          data: {
            permission: {
              role: [Roles.Admin],
              redirectTo: '403'
            }
          }
        },
        {
          path: 'report',
          loadChildren: './report/report.module#ReportModule'
        },
        {
          path: 'survey',
          loadChildren: './survey/survey.module#SurveyModule',
          data: {
            permission: {
              role: [Roles.Admin],
              redirectTo: '403'
            }
          }
        },
        {
          path: 'contract',
          loadChildren: './contract/contract.module#ContractModule',
          canActivate: [ Authguard ],
          data: {
            permission: {
              role: [Roles.Admin],
              redirectTo: '403'
            }
          }
        },
        {
          path: 'change-password',
          component: ChangePasswordComponent,
          data: { title: 'Change Password' }
        }
      ]
    }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})

export class HomeRoutingModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/home-routing.module.ts